import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';
import { CssSelectors } from '../../../styles/styles';

const {
	colors,
	spacing,
	typography: { fontSizes },
	common,
} = THEME;

export const styleSheet = StyleSheet.create({
	container: {
		minWidth: 500,
		maxWidth: 700,
		display: 'flex',
		flexDirection: 'column',
		height: '80vh',
		maxHeight: 600,
	},
	scrollableContent: {
		flex: 1,
		overflowY: 'auto',
		padding: spacing.lg,
		...CssSelectors.allChildren({
			':not(:first-child)': {
				marginTop: spacing.md,
			},
		}),
	},
	label: {
		color: colors.text.light,
		display: 'block',
		fontSize: fontSizes.sm,
		marginBottom: spacing.sm,
	},
	sectionHeader: {
		marginTop: spacing.lg,
		marginBottom: spacing.md,
	},
	sectionDescription: {
		color: colors.text.light,
		fontSize: fontSizes.xs,
		margin: `${spacing.xs}px 0 0 0`,
		lineHeight: 1.4,
	},
	tooltip: {
		marginLeft: spacing.xs,
	},
	tooltipContent: {
		backgroundColor: colors.background.light,
		border: common.border,
		borderRadius: common.borderRadius,
		fontSize: fontSizes.xs,
		lineHeight: 1.4,
		width: 350,
		padding: spacing.sm,
		whiteSpace: 'normal',
		wordWrap: 'break-word',
		overflowWrap: 'break-word',
		boxSizing: 'border-box',
	},
	userSelectBox: {
		flex: 1,
		marginLeft: spacing.sm,
		maxWidth: '50%',
	},
	buttonRow: {
		alignItems: 'center',
		display: 'flex',
		gap: spacing.sm,
		justifyContent: 'flex-end',
		padding: spacing.lg,
		backgroundColor: colors.background.light,
	},
	previewHeader: {
		alignItems: 'center',
		borderBottom: common.border,
		display: 'flex',
		justifyContent: 'space-between',
		marginBottom: spacing.md,
		paddingBottom: spacing.sm,
	},
	previewContent: {
		backgroundColor: colors.background.main,
		border: common.border,
		borderRadius: common.borderRadius,
		fontFamily: 'monospace',
		fontSize: fontSizes.xs,
		lineHeight: 1.4,
		marginBottom: spacing.md,
		maxHeight: 400,
		overflow: 'auto',
		padding: spacing.md,
	},
});
